import { Tag } from "primereact/tag";

const labels: Record<string, string> = {
    DRAFT: "Rascunho",
    RECEIVED: "Recebido",
    CANCELLED: "Cancelado",
    PENDING: "Pendente",
    IN_PROGRESS: "Em andamento",
    STAGED: "No Pulmão",
    PICKED: "Pré-baixado",
    COMPLETED: "Concluído",
    OPEN: "Aberto",
    ALLOCATED: "Alocado",
    COUNTING: "Em contagem",
    PENDING_RELEASE: "Aguardando qualidade",
    RELEASED: "Liberado",
    RETAINED: "Retido",
    BLOCKED: "Bloqueado",
    ACTIVE: "Ativo",
    CLOSED: "Fechado",
};
const severities: Record<string, "success" | "warning" | "danger" | "info" | "secondary"> = {
    RECEIVED: "success",
    COMPLETED: "success",
    RELEASED: "success",
    ACTIVE: "success",
    PENDING: "warning",
    DRAFT: "secondary",
    OPEN: "info",
    ALLOCATED: "info",
    IN_PROGRESS: "info",
    COUNTING: "info",
    STAGED: "warning",
    PICKED: "warning",
    PENDING_RELEASE: "warning",
    RETAINED: "danger",
    BLOCKED: "danger",
    CANCELLED: "danger",
    CLOSED: "secondary",
};
export function StatusTag({ value }: { value: string }) {
    return <Tag value={labels[value] ?? value} severity={severities[value] ?? "secondary"} rounded />;
}
